import clsx from 'clsx';
import React from 'react';

import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { useToggle } from '@/src/hooks/useToggle';

import LineItemsSummaryTable from './LineItemsSummaryTable/LineItemsSummaryTable';

import ActionButton from '../../Elements/ActionButton/ActionButton';

const LineItems = ({ isDisplayView = false, lineItems, children, isPrefilled }) => {
  const [showModal, toggleShowLineItemsModal] = useToggle(false);

  return (
    <div
      className={clsx(
        'container--lineItems',
        'tw-py-[20px] tw-mt-[10px]',
        'tw-border-solid tw-border-y-[1px] tw-border-y-cfo-grey-500'
      )}
    >
      <div className={clsx('tw-flex tw-items-center tw-justify-between')}>
        <h4
          className={clsx(
            // (!) is not removed here as it is to override the styles from vendor.css
            '!tw-text-[14px] tw-font-brandonTextMedium',
            '!tw-my-[10px]',
            isDisplayView ? 'tw-text-cfo-black' : 'tw-text-cfo-grey-600'
          )}
        >
          Entry
        </h4>
        <ActionButton
          className={clsx(
            'tw-px-[5px] tw-text-[12px]',
            isDisplayView
              ? 'hover:tw-stroke-cfo-blue-600'
              : 'hover:tw-bg-cfo-blue-600 hover:tw-text-white'
          )}
          buttonType={isDisplayView ? 'style_unset' : 'primary_light_blue'}
          onClick={toggleShowLineItemsModal}
        >
          {isDisplayView ? (
            <Icon
              icon={ICONS.expand_icon({
                mainClassName: 'tw-w-[14px] tw-h-[14px]',
                fillClassName: 'group-hover:tw-stroke-cfo-blue-600',
              })}
            />
          ) : (
            <>
              <Icon icon={ICONS.edit} className={clsx('tw-text-[16px] tw-mr-[5px]')} />
              Edit Line Entries
            </>
          )}
        </ActionButton>
      </div>

      <LineItemsSummaryTable
        lineItems={lineItems}
        isDisplayView={isDisplayView}
        isPrefilled={isPrefilled}
      />

      {showModal &&
        children &&
        React.cloneElement(children, {
          onClose: (...args) => {
            if (children.props.onClose) {
              children.props.onClose(...args);
            }

            toggleShowLineItemsModal();
          },
        })}
    </div>
  );
};

export default LineItems;
